import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/fastenalSafetyReport'
import Component from 'components/Reports/FastenalSafetyReport'

export default createListViewContainer({ actions, selectors: selectors.fastenalSafetyReport })(Component)
